import {motion} from 'framer-motion';
import {Button, closeCurrentDialog} from 'platform/components';
import {Box, Right, VStack} from 'platform/foundation';

import {useEffect, useState} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {TemplateContextEnum} from '@dms/api/core';
import i18n from '@dms/i18n';
import {useRenderTemplateExample} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';
import {EmailWindow} from '@dms/shared-aftersales';

interface EmailPreviewProps {
  context: TemplateContextEnum;
  body: string;
  subject: string;
}

export function EmailPreview(props: EmailPreviewProps) {
  const {renderEmail, isLoading} = useRenderTemplateExample(props.context);

  const [htmlData, setHtmlData] = useState<string | null>(null);

  const handleRenderEmail = () => {
    renderEmail?.({
      body: {body: props.body, subject: props.subject},
    })
      .unwrap()
      .then((data) => data.body)
      .then(setHtmlData)
      .catch(handleApiError);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => handleRenderEmail(), [props.body, props.subject]);

  return (
    <VStack spacing={4}>
      <Box position="relative">
        <motion.div>
          <VStack height="100%">
            <Box position="relative" height="100%">
              <EmailWindow
                htmlData={htmlData}
                isRerendering={isLoading && isNotNilOrEmpty(htmlData)}
                data-testid="customerEmailForm-email-window"
              />
            </Box>
          </VStack>
        </motion.div>
      </Box>
      <Right>
        <Button
          title={i18n.t('general.actions.close')}
          onClick={closeCurrentDialog}
          variant="secondary"
        />
      </Right>
    </VStack>
  );
}
